<a class="order-detail__back" routerLink="/perfil/pedidos">
  <app-icon [icon]="backIcon" [size]="16" />
  {{ copy.BACK }}
</a>

@switch (state().status) {
  @case ('blocked') {
    <app-profile-orders-unverified />
  }

  @case ('loading') {
    <div class="order-detail__skeleton" aria-busy="true">
      <span class="order-detail__skeleton-line order-detail__skeleton-line--title"></span>
      <span class="order-detail__skeleton-line"></span>
      <span class="order-detail__skeleton-line"></span>
      <span class="order-detail__skeleton-line order-detail__skeleton-line--short"></span>
    </div>
  }

  @case ('not-found') {
    <p class="order-detail__message">{{ notFoundMessage() }}</p>
  }

  @case ('error') {
    <div class="order-detail__error" role="alert">
      <p class="order-detail__message">{{ loadCopy.LOAD_ERROR }}</p>
      <app-button variant="secondary" size="sm" (click)="retry()">{{ loadCopy.RETRY }}</app-button>
    </div>
  }

  @case ('loaded') {
    @if (order(); as order) {
      <article class="order-detail">
        <header class="order-detail__header">
          <div class="order-detail__title-row">
            <h2 class="order-detail__number">{{ order.number }}</h2>
            <app-badge [variant]="statusVariant(order.status.key)">{{ order.status.label }}</app-badge>
          </div>
          <p class="order-detail__meta">
            @if (formatIsoDate(order.date); as date) {
              <span class="order-detail__date">{{ date }}</span>
            }
            <span class="order-detail__kind">{{ order.kind.label }}</span>
          </p>
        </header>

        <!-- Productos -->
        <section class="order-detail__section">
          <h3 class="order-detail__section-title">{{ copy.PRODUCTS }}</h3>
          <ul class="order-detail__lines" role="list">
            @for (line of order.lines; track $index) {
              <li class="order-line">
                @if (lineImage(order, $index, line.image); as src) {
                  <img
                    class="order-line__image"
                    [src]="src"
                    [alt]="line.name"
                    loading="lazy"
                    width="56"
                    height="56"
                    (error)="onImageError(order, $index)"
                  />
                } @else {
                  <span class="order-line__image order-line__image--missing" aria-hidden="true">
                    <app-icon [icon]="packageIcon" [size]="22" />
                  </span>
                }
                <span class="order-line__info">
                  <span class="order-line__name">{{ line.name }}</span>
                  <span class="order-line__quantity">{{ quantityLabel(line.quantity) }}</span>
                </span>
                <span class="order-line__total">{{ formatCrc(line.total) }}</span>
              </li>
            }
          </ul>
        </section>

        <!-- Entrega y totales -->
        <section class="order-detail__section order-detail__totals">
          @if (order.delivery; as delivery) {
            <div class="order-detail__row order-detail__delivery">
              <span>
                {{ copy.DELIVERY }}: {{ delivery.label }}
                @if (delivery.shop_name) {
                  <span class="order-detail__shop">({{ delivery.shop_name }})</span>
                }
              </span>
              @if (delivery.amount > 0) {
                <span class="order-detail__amount">{{ formatCrc(delivery.amount) }}</span>
              }
            </div>
          }
          @if (order.discount > 0) {
            <div class="order-detail__row order-detail__discount">
              <span>{{ copy.DISCOUNT }}</span>
              <span class="order-detail__amount">{{ formatCrc(-order.discount) }}</span>
            </div>
          }
          <div class="order-detail__row order-detail__row--total">
            <span>{{ copy.TOTAL }}</span>
            <span class="order-detail__amount">{{ formatCrc(order.total) }}</span>
          </div>
        </section>

        <!-- Pago (B7): bloques separados que no se mezclan -->
        @if (hasPayment(order)) {
          <section class="order-detail__section order-detail__payment">
            <h3 class="order-detail__section-title">{{ copy.PAYMENT }}</h3>

            @if (order.payment.method; as method) {
              <p class="payment-block payment-block--method">
                <span class="payment-block__label">{{ copy.PAYMENT_METHOD }}</span>
                <span>{{ method.label }}</span>
              </p>
            }

            @if (order.payment.receipts.length > 0) {
              <div class="payment-block payment-block--receipts">
                <span class="payment-block__label">{{ copy.RECEIPTS }}</span>
                <ul class="payment-receipts" role="list">
                  @for (receipt of order.payment.receipts; track $index) {
                    <li class="payment-receipt">
                      <span class="payment-receipt__amount">{{ formatCrc(receipt.amount) }}</span>
                      <span class="payment-receipt__method">{{ receipt.method?.label ?? copy.MISSING }}</span>
                      <span class="payment-receipt__date">{{ formatIsoDate(receipt.date) || copy.MISSING }}</span>
                    </li>
                  }
                </ul>
              </div>
            }

            @if (order.payment.online_status; as online) {
              <p class="payment-block payment-block--card">{{ online.label }}</p>
            }

            @if (order.payment.proof_received) {
              <p class="payment-block payment-block--proof">{{ copy.PROOF_RECEIVED }}</p>
            }

            @if (order.payment.layaway; as layaway) {
              <p class="payment-block payment-block--layaway">{{ layawayText(layaway) }}</p>
            }

            @if (order.payment.note; as note) {
              <p class="payment-block payment-block--note">{{ note }}</p>
            }
          </section>
        }
      </article>
    }
  }
}
